import {INVENTORY_ITEMS} from '../../constants/inventoryItems';
import {getPartnerRewardDisplayProps} from './getPartnerRewardDisplayProps';

/**
 * Название награды для ТЕКСТОВОГО сообщения. В интерфейсе у валют рядом стоит
 * иконка, поэтому fullLabel для них — голое число; в тексте единицу измерения
 * нужно писать словом.
 */
const getRewardShareLabel = (reward) => {
  const display = getPartnerRewardDisplayProps(reward);
  if (!display.isKnown) {
    return null;
  }

  switch (display.itemType) {
    case INVENTORY_ITEMS.NUMENS:
      return `${display.amountLabel} нуменов`;
    case INVENTORY_ITEMS.CRYSTALS:
      return `${display.amountLabel} кристаллов`;
    default:
      return display.fullLabel;
  }
};

/**
 * Сообщение для кнопки «Поделиться» на странице приглашения друга: короткая
 * подводка про игру, перечень наград, которые получит именно ПРИГЛАШЕННЫЙ (их
 * состав задается в админке и приходит с /friend-referal/config), и ссылка.
 *
 * Награды могут быть еще не загружены или не настроены — тогда список просто
 * опускается, а сообщение остается осмысленным.
 *
 * @param {string} referalUrl - реферальная ссылка приглашающего
 * @param {Array} friendRewards - награды друга за регистрацию
 * @returns {string}
 */
export const buildFriendInviteShareMessage = (referalUrl, friendRewards) => {
  const rewardLabels = (friendRewards || [])
    .map(getRewardShareLabel)
    .filter(Boolean);

  const lines = [
    '⚔️ Зову тебя в «Стратегикон» — пошаговую стратегию на гексах: свои города, фракции, снабжение и битвы.',
  ];

  if (rewardLabels.length > 0) {
    lines.push('');
    lines.push('Регистрируйся по моей ссылке — подарок новичку уже ждет:');
    rewardLabels.forEach((label) => lines.push(`• ${label}`));
  } else {
    lines.push('');
    lines.push('Регистрируйся по моей ссылке — новичков встречают с подарком.');
  }

  lines.push('');
  lines.push(referalUrl);

  return lines.join('\n');
};

/**
 * Картинка для вложения в нативное «Поделиться»: если среди наград друга есть
 * сундук — его изображение (наглядно показывает подарок), иначе null, и
 * getShareImageFile возьмет картинку по умолчанию.
 *
 * Сундук с неизвестным id пропускается: iconSrc у него нет (см. isKnown в
 * getPartnerRewardDisplayProps).
 *
 * @param {Array} friendRewards - награды друга за регистрацию
 * @returns {string|null} путь к картинке или null
 */
export const getFriendInviteShareImageUrl = (friendRewards) => {
  const chestReward = (friendRewards || []).find(
    (reward) => reward?.itemType === INVENTORY_ITEMS.CHEST
  );
  if (!chestReward) {
    return null;
  }

  const display = getPartnerRewardDisplayProps(chestReward);
  return display.isKnown ? display.iconSrc : null;
};
